import React, { useMemo, useEffect, memo } from 'react';
import { ContentAdDesktop } from 'app/styles/content';
import { Helmet } from 'react-helmet-async';
import StickyMobileBannerAdSlot from 'app/components/ads/StickyMobileBannerAdSlot';
import styled from 'styled-components';
import { useRestoreData } from 'app/hooks/dataHooks';
import { SIZES } from '@fupa/fupa-uikit';
import { useSearchParam } from 'app/hooks/useSearchParams';
import DistrictMainPageState from 'app/routes/district/mainPage/models/DistrictMainPageState';
import UserFeedbackFab from 'app/components/floatingAction/UserFeedbackFab';
import { useEarlyAccessFeatureRedirect } from 'app/earlyAccess/useEarlyAccessFeatureRedirect';
import EarlyFeatureAccessFabLoader from 'app/components/earlyFeatureAccess/EarlyFeatureAccessFabLoader';
import { initSessionReplayIntegration } from 'app/hooks/useSentrySessionReplay';
import useInitPosthog from 'app/hooks/useInitPosthog';
import ParamBasedMainPageContent from 'app/components/district/mainPage/ParamBasedMainPageContent';
import MainPageContent from 'app/components/district/mainPage/MainPageContent';
import useLastDistricts from 'app/hooks/useLastDistricts';
import { useParams } from 'react-router';
import useTrackTimeOnPage from 'app/hooks/useTrackTimeOnPage';
const CustomContentAdDesktop = styled(ContentAdDesktop).withConfig({
  componentId: "sc-10lygmf-0"
})(["display:flex;flex-direction:column;& > *:not(:first-child){margin-bottom:", ";}"], SIZES['16']);
export default function DistrictMainPage(_ref) {
  let {
    name
  } = _ref;
  useTrackTimeOnPage();
  useEarlyAccessFeatureRedirect();
  useInitPosthog(0.0001);
  const page = useSearchParam('page');
  const {
    districtSlug
  } = useParams();
  const {
    restoredData
  } = useRestoreData('DistrictMainPage');
  const initialState = useMemo(() => new DistrictMainPageState(restoredData), [restoredData]);
  useLastDistricts(districtSlug);
  useEffect(() => {
    initSessionReplayIntegration();
  }, []);
  const meta = useMemo(() => [{
    name: 'description',
    content: "Fu\xDFballkreis ".concat(name, " - Alle wichtigen Informationen zum Amateurfu\xDFball im Fu\xDFballkreis ").concat(name, ".")
  }, {
    name: 'robots',
    content: 'index, follow'
  }], [name]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(CustomContentAdDesktop, {
    bgColor: "none",
    top: "7.125rem",
    contentPaddingBottom: '4.5rem',
    fabBtn: /*#__PURE__*/React.createElement(FabButtons, null),
    "data-sentry-element": "CustomContentAdDesktop",
    "data-sentry-source-file": "DistrictMainPage.tsx"
  }, /*#__PURE__*/React.createElement(Helmet, {
    meta: meta,
    "data-sentry-element": "Helmet",
    "data-sentry-source-file": "DistrictMainPage.tsx"
  }), page && page !== '1' ? /*#__PURE__*/React.createElement(ParamBasedMainPageContent, {
    initialState: initialState.competitions
  }) : /*#__PURE__*/React.createElement(MainPageContent, {
    name: name,
    initialState: initialState
  })), /*#__PURE__*/React.createElement(StickyMobileBannerAdSlot, {
    "data-sentry-element": "StickyMobileBannerAdSlot",
    "data-sentry-source-file": "DistrictMainPage.tsx"
  }));
}
const FabButtons = /*#__PURE__*/memo(() => {
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(UserFeedbackFab, null), /*#__PURE__*/React.createElement(EarlyFeatureAccessFabLoader, null));
});